import { css, StyleSheet } from 'aphrodite'
import { Auth } from 'aws-amplify'
import React, { useEffect, useState, useContext } from 'react'
import { useTranslation } from 'react-i18next'
import { Route, Routes, useLocation, Navigate } from 'react-router-dom'
import LayoutSidePanel from '../../components/Layout/LayoutSidePanel'
import UILogo from '../../components/UI/UILogo'
import UIUserMenuLink from '../../components/UI/UIUserMenuLink'
import { COLOR_GRAY__100 } from '../../lib/colors'
import RequestsDashboard from './RequestsDashboard'
import { useNavigate } from 'react-router-dom'
import layerDrop from '../../../src/assets/layerDrop.png'
import {
  IconAlert,
  IconClose,
  IconHome,
  IconLogOut,
  IconMap,
  IconMessage,
  IconRightArrow,
  IconUser,
} from '../../components/Icon'
import config from '../../config'
import InvoiceDashboard from './InvoiceDashboard'
import MyAccount from './MyAccount'
import RequestDetail from './RequestDetail'
import RequestsDashboardMobile from './RequestsDashboardMobile'
import LiveContext from '../../components/Context/LiveContext'
import DeleteAccount from './DeleteAccount'

const styles = StyleSheet.create({
  hasScroll: {
    height: '100vh',
    overflow: 'hidden',
  },
  container: {
    width: '100%',
    '@media (max-width: 480px)': {
      backgroundColor: '#FAFAFA',
    },
  },
  containerSidePanel: {
    display: 'flex',
    justifyContent: 'center',
  },
  containerContentPanel: {
    backgroundColor: COLOR_GRAY__100,
    padding: '10px',
    '@media (max-width: 480px)': {
      padding: '0px',
      backgroundColor: '#fff',
    },
  },
  // Styles for XS design (mobile)
  navbar: {
    position: 'absolute',
    zIndex: 10,
    width: '100vw',
  },
  title: {
    letterSpacing: '-0.05em',
    padding: '100px 0px 10px 20px',
    fontWeight: 700,
    fontSize: '1.5em',
    lineHeight: '.9em',
    margin: '0px',
  },
  subtitle: {
    letterSpacing: '-0.05em',
    margin: '0px',
    padding: '0px 0px 20px 20px',
    fontSize: '1em',
    color: '#718096',
  },
  popModule: {
    position: 'absolute',
    width: '70%',
    height: '100vh',
    top: '0',
    right: '0',
    backgroundColor: 'white',
    boxShadow: '0px 4px 4px rgba(0, 0, 0, 0.25)',
    zIndex: '10',
  },
  iconCont: {
    display: 'flex',
    width: '100%',
    margin: '10% 5% 10% 5%',
    gap: '20px',
  },
  dropdown: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'flex-start',
    padding: '3px',
    gap: '10px',
    position: 'absolute',
    width: '60px',
    height: '40px',
    right: '20px',
    top: '15.17px',
    /* Theme/Light/Tertiary */
    background: '#61C4CE',
    borderRadius: '29px',
    '@media (max-width: 480px)': {
      zIndex: 100,
    },
  },
  layer: {
    width: '100%',
  },
  logo: {
    position: 'absolute',
    height: 'auto',
    left: '20px',
    top: '15.17px',
    '@media (max-width: 1024px)': {
      position: 'relative',
      width: '100px',
    },
    '@media (max-width: 480px)': {
      position: 'absolute',
      height: 'auto',
      left: '20px',
      top: '15.17px',
    },
  },
  logoStyle: {
    width: '200px',
  },
  headerMobile: {
    position: 'fixed',
    backgroundColor: 'white',
    width: '100%',
    height: '80px',
  },
})

const ViewerAccount = () => {
  const { t } = useTranslation('translation')
  const navigate = useNavigate()

  const { setUserLogged, isLivePreviewOpened } = useContext(LiveContext)

  const location = useLocation()
  const [popIsOut, setPopOut] = useState(false)

  let path = location?.pathname?.substring(
    location?.pathname?.lastIndexOf('/') + 1
  )

  useEffect(() => {
    if (path) {
      handleActiveTab(path)
    }
  }, [location])

  const handleActiveTab = async (path) => {
    if (path === 'home') {
      navigate('/')
    } else if (path === 'logOut') {
      localStorage.removeItem('access_token')
      localStorage.removeItem('userMaker')
      Auth.signOut({ global: false }).then(() => {
        setUserLogged(false)
        navigate('/')
      })
    }
  }

  const ListSideMenu = [
    {
      route: '/create-request',
      label: `${t('pages.viewerAccount.menu.home')}`,
    },
    {
      route: 'demand',
      label: `${t('pages.viewerAccount.menu.demand')}`,
    },
    {
      route: 'invoice',
      label: `${t('pages.viewerAccount.menu.invoice')}`,
    },
    {
      route: 'account',
      label: `${t('pages.viewerAccount.menu.account')}`,
    },
    {
      route: 'contactUs',
      label: `${t('pages.viewerAccount.menu.contactUs')}`,
      contact: config.CONTACT_MAIL,
    },
    {
      route: 'delete-account',
      label: `${t('pages.viewerAccount.menu.deleteAccount')}`,
    },
    {
      route: 'logOut',
      label: `${t('pages.viewerAccount.menu.logOut')}`,
    },
  ]

  const popMobile = () => {
    const navigate = useNavigate()
    return (
      <>
        {popIsOut && (
          <div className={css(styles.popModule)}>
            <div
              onClick={() => {
                setPopOut(false)
              }}
              className={css(styles.iconCont)}
              style={{ paddingBottom: '20%' }}
            >
              <IconClose dynamicStyle={styles.icon} color="#A0AEC0"></IconClose>
            </div>
            <div
              onClick={() => {
                navigate(ListSideMenu.at(0).route)
                setPopOut(false)
              }}
              className={css(styles.iconCont)}
            >
              <IconHome dynamicStyle={styles.icon} color="#A0AEC0"></IconHome>
              <div
                style={{ color: '#A0AEC0', fontWeight: '600', height: 'auto' }}
              >
                {ListSideMenu.at(0).label}
              </div>
            </div>
            <div
              onClick={() => {
                navigate(ListSideMenu.at(1).route)
                setPopOut(false)
              }}
              className={css(styles.iconCont)}
            >
              <IconMap dynamicStyle={styles.icon} color="#A0AEC0"></IconMap>
              <div
                style={{ color: '#A0AEC0', fontWeight: '600', height: 'auto' }}
              >
                {ListSideMenu.at(1).label}
              </div>
            </div>
            <div
              onClick={() => {
                navigate(ListSideMenu.at(2).route)
                setPopOut(false)
              }}
              className={css(styles.iconCont)}
            >
              <IconRightArrow
                dynamicStyle={styles.icon}
                color="#A0AEC0"
              ></IconRightArrow>
              <div
                style={{ color: '#A0AEC0', fontWeight: '600', height: 'auto' }}
              >
                {ListSideMenu.at(2).label}
              </div>
            </div>
            <div
              onClick={() => {
                navigate(ListSideMenu.at(3).route)
                setPopOut(false)
              }}
              className={css(styles.iconCont)}
              style={{ paddingBottom: '20%' }}
            >
              <IconAlert dynamicStyle={styles.icon} color="#A0AEC0"></IconAlert>
              <div
                style={{ color: '#A0AEC0', fontWeight: '600', height: 'auto' }}
              >
                {ListSideMenu.at(3).label}
              </div>
            </div>
            <div className={css(styles.iconCont)}>
              <IconUser dynamicStyle={styles.icon} color="#A0AEC0"></IconUser>
              <a
                href={`mailto:${ListSideMenu.at(4).contact}`}
                style={{
                  color: '#A0AEC0',
                  fontWeight: '600',
                  height: 'auto',
                  textDecoration: 'none',
                }}
              >
                {ListSideMenu.at(4).label}
              </a>
            </div>
            <div
              onClick={() => {
                navigate(ListSideMenu.at(5).route)
                setPopOut(false)
              }}
              className={css(styles.iconCont)}
            >
              <IconMessage
                dynamicStyle={styles.icon}
                color="#A0AEC0"
              ></IconMessage>
              <div
                style={{ color: '#A0AEC0', fontWeight: '600', height: 'auto' }}
              >
                {ListSideMenu.at(5).label}
              </div>
            </div>
            <div
              onClick={() => {
                navigate(ListSideMenu.at(6).route)
                setPopOut(false)
              }}
              className={css(styles.iconCont)}
            >
              <IconLogOut
                dynamicStyle={styles.icon}
                color="#A0AEC0"
              ></IconLogOut>
              <div
                style={{ color: '#A0AEC0', fontWeight: '600', height: 'auto' }}
              >
                {ListSideMenu.at(6).label}
              </div>
            </div>
          </div>
        )}
      </>
    )
  }

  return (
    <>
      {window.innerWidth <= 1024 ? (
        <div className={css(styles.headerMobile)}>
          <UILogo dynamicStyle={styles.logo} logoWhite={false}></UILogo>
          <div
            className={css(styles.dropdown)}
            onClick={() => {
              setPopOut(true)
            }}
          >
            <img className={css(styles.layer)} src={layerDrop}></img>
          </div>
          {popMobile()}
        </div>
      ) : (
        <></>
      )}
      <div className={css(styles.container)}>
        <LayoutSidePanel
          dynamicStyle={isLivePreviewOpened ? styles.hasScroll : null}
          xs={window.innerWidth <= 1024}
          menu={
            <>
              {window.innerWidth <= 1024 ? (
                <></>
              ) : (
                <>
                  <div className={css(styles.containerSidePanel)}>
                    <UILogo logoStyle={styles.logoStyle} whiteLogo={false} />
                  </div>
                  <br />
                  {ListSideMenu.map((menu, key) => {
                    return (
                      <UIUserMenuLink
                        key={key}
                        contact={menu?.contact}
                        route={menu.route}
                        text={menu.label}
                        onClick={() => {
                          handleActiveTab(menu.route)
                        }}
                      />
                    )
                  })}
                </>
              )}
            </>
          }
        >
          <div className={css(styles.containerContentPanel)}>
            <Routes>
              <Route index element={<Navigate to="demand" replace />} />
              <Route
                path="demand"
                element={
                  window.innerWidth < 480 ? (
                    <RequestsDashboardMobile />
                  ) : (
                    <RequestsDashboard />
                  )
                }
              />
              <Route path="invoice" element={<InvoiceDashboard />} />
              <Route path="dispute" element={<div>dispute</div>} />
              <Route path="account" element={<MyAccount />} />
              <Route path="contactUs" element={<div>contactUs</div>} />
              <Route path="delete-account" element={<DeleteAccount />} />
              <Route path="demand/:requestId" element={<RequestDetail />} />
            </Routes>
          </div>
        </LayoutSidePanel>
      </div>
    </>
  )
}

export default ViewerAccount
